import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { Address } from "@/location/components";
import { useLocation } from "@/location/hooks/useLocation";
import { LocationDescription } from "../Description/LocationDescription"; // FIXME add @/description/components in tsconfig
import { MapCard } from "@/location/components/MapCard/MapCard";
import { useI18n } from "@/shared/hooks";
import { useRefsContext } from "@/contexts/ref";
import { Section, Title } from "@/components/UI";
import { PublicTransports } from "./components/PublicTransports/PublicTransports";
import { Divider } from "@gemini/ui";
import { MapStreetView, MapTravelTimeEntry } from "@/domains/map";
export const locationTestId = "cdp-location";
export const Location = () => {
    const location = useLocation();
    const { t } = useI18n();
    const { locationRef } = useRefsContext();
    if (!location)
        return null;
    return (_jsxs(Section, { ref: locationRef, testId: locationTestId, children: [_jsx(Title, { title: t("area.title"), testId: `${locationTestId}-title`, variant: "section", hasMargin: true, id: "location" }), _jsx(LocationContent, {})] }));
};
const LocationContent = () => {
    return (_jsxs(_Fragment, { children: [_jsx(Address, {}), _jsx(MapCard, {}), _jsxs(Box, { marginTop: "spacing.16", display: "flex", flexDirection: "column", gap: {
                    "breakpoint.base": "spacing.8",
                    "breakpoint.lg": "spacing.4",
                }, children: [_jsx(PublicTransports, {}), _jsx(Divider, { "aria-hidden": "true", marginVertical: {
                            "breakpoint.base": "spacing.16",
                        } }), _jsx(MapStreetView, { variant: "preview" }), _jsx(MapTravelTimeEntry, {})] }), _jsx(LocationDescription, {})] }));
};
